import React, {} from "react";
import { colors, css, fonts, glyphs } from "../../../Styles";
import { useTranslation } from "react-i18next";
import { WaitAnimation } from "../../BaseComponents";
import { TFunction } from "i18next";

// #region | Labels
export const getGateMotorConfig = (t:TFunction): Record<number, StationConfig> => ({
  0: {label: t("configs.gateMotor.unknown", {defaultValue: "Unknown"}), color: colors.greyDarkPrimary, glyph: <></>},
  1: {label: t("configs.gateMotor.noGate", {defaultValue: "No Gate"}), color: colors.greyDarkPrimary, glyph: <></>},
  2: {label: t("configs.gateMotor.gateClosed", {defaultValue: "Gate closed"}), color: colors.greyDarkPrimary, glyph: <></>},
  3: {label: t("configs.gateMotor.gateClosing", {defaultValue: "Gate closing"}), color: colors.greyDarkPrimary, glyph: <></>},
  4: {label: t("configs.gateMotor.gateOpen", {defaultValue: "Gate open"}), color: colors.greyDarkPrimary, glyph: <></>},
  5: {label: t("configs.gateMotor.gateOpening", {defaultValue: "Gate opening"}), color: colors.greyDarkPrimary, glyph: <></>}
});

export const getFeedMotorConfig = (t:TFunction): Record<number, StationConfig> => ({
  1: {label: t("configs.feedMotor.init", {defaultValue: "Initilazing"}), color: colors.greyDarkPrimary, glyph: <></>},
  2: {label: t("configs.feedMotor.idle", {defaultValue: "Idle"}), color: colors.greyDarkPrimary, glyph: <></>},
  3: {label: t("configs.feedMotor.running", {defaultValue: "Running"}), color: colors.greyDarkPrimary, glyph: <></>},
  4: {label: t("configs.feedMotor.bookCal", {defaultValue: "Book Calibrate"}), color: colors.greyDarkPrimary, glyph: <></>},
  5: {label: t("configs.feedMotor.bookEmpty", {defaultValue: "Book Empty"}), color: colors.greyDarkPrimary, glyph: <></>},
  19: {label: t("configs.feedMotor.starting", {defaultValue: "Starting"}), color: colors.greyDarkPrimary, glyph: <></>},
  20: {label: t("configs.feedMotor.cal", {defaultValue: "Calibrate"}), color: colors.greyDarkPrimary, glyph: <></>},
  21: {label: t("configs.feedMotor.empty", {defaultValue: "Empty"}), color: colors.greyDarkPrimary, glyph: <></>},
  239: {label: t("configs.feedMotor.end", {defaultValue: "End"}), color: colors.greyDarkPrimary, glyph: <></>},
  240: {label: t("configs.feedMotor.retry", {defaultValue: "Retry"}), color: colors.greyDarkPrimary, glyph: <></>},
  241: {label: t("configs.feedMotor.safetyOne", {defaultValue: "Safety 1"}), color: colors.greyDarkPrimary, glyph: <></>},
  242: {label: t("configs.feedMotor.safetyTwo", {defaultValue: "Safety 2"}), color: colors.greyDarkPrimary, glyph: <></>},
  243: {label: t("configs.feedMotor.safetyThree", {defaultValue: "Safety 3"}), color: colors.greyDarkPrimary, glyph: <></>},
  254: {label: t("configs.feedMotor.error", {defaultValue: "Error"}), color: colors.systemRed, glyph: <></>},
})

type StationConfig = {
  label: string;
  glyph: JSX.Element;
  color: colors;
}

const glyphAnimation = <glyphs.Setting fillColor={colors.greyPrimary} size="35px" animation/>

export const getStationStatusConfig = (t:TFunction): Record<number, StationConfig> => ({
  1: { label: t("configs.stationStatus.creation", {defaultValue: "Creation"}), glyph: glyphAnimation, color: colors.systemYellow },
  2: { label: t("configs.stationStatus.init", {defaultValue: "Initializing"}), glyph: <glyphs.Setting fillColor={colors.greyPrimary} size="35px" />, color: colors.greyDarkPrimary },
  3: { label: t("configs.stationStatus.termCheck", {defaultValue: "Term Check"}), glyph: glyphAnimation, color: colors.systemYellow },
  5: { label: t("configs.stationStatus.calibrate", {defaultValue: "Calibrate"}), glyph: glyphAnimation, color: colors.systemYellow },
  16: { label: t("configs.stationStatus.idle", {defaultValue: "idle"}), glyph: <glyphs.Setting fillColor={colors.greyPrimary} size="35px" />, color: colors.greyDarkPrimary },
  19: { label: t("configs.stationStatus.waitingTag", {defaultValue: "Waiting Tag"}), glyph: glyphAnimation, color: colors.systemYellow },
  20: { label: t("configs.stationStatus.fetchFeeding", {defaultValue: "Fetch Feeding"}), glyph: glyphAnimation, color: colors.systemYellow },
  32: { label: t("configs.stationStatus.oneFeeding", {defaultValue: "1 Feeding"}), glyph: glyphAnimation, color: colors.systemGreen },
  33: { label: t("configs.stationStatus.spray", {defaultValue: "Spray"}), glyph: glyphAnimation, color: colors.systemGreen },
  34: { label: t("configs.stationStatus.feeding", {defaultValue: "Feeding"}), glyph: glyphAnimation, color: colors.systemGreen },
  48: { label: t("configs.stationStatus.waitingLeave", {defaultValue: "Waiting Leave"}), glyph: glyphAnimation, color: colors.systemYellow },
  224: { label: t("configs.stationStatus.blocked", {defaultValue: "Blocked"}), glyph: <glyphs.Attention fillColor={colors.systemRed} size="35px" />, color: colors.systemRed },
  239: { label: t("configs.stationStatus.disabled", {defaultValue: "Disabled"}), glyph: <glyphs.Attention fillColor={colors.systemRed} size="35px" />, color: colors.systemRed },
  240: { label: t("configs.stationStatus.error", {defaultValue: "Error"}), glyph: <glyphs.Attention fillColor={colors.systemRed} size="35px" />, color: colors.systemRed },
  255: { label: t("configs.stationStatus.end", {defaultValue: "End"}), glyph: <glyphs.Attention fillColor={colors.systemRed} size="35px" />, color: colors.systemRed }
});
// #endregion

/* eslint-disable */
export enum EsfStationSizes {
  small = "small",
  normal = "normal",
}
/* eslint-enable */
interface EsfStationProps {
  size?: EsfStationSizes;
  pins?: {
    feedMotor?: number;
    gateMotor?: number;
    components?: boolean;
  };
}

export function EsfStationMCore({ size, pins }: EsfStationProps) {
  const { t } = useTranslation();
  const feedMotorConfig = getFeedMotorConfig(t);
  const gateMotorConfig = getGateMotorConfig(t);

  const gateMotorText = pins?.gateMotor && gateMotorConfig[Number(pins.gateMotor)]?.label

  const feedMotorText = pins?.feedMotor && feedMotorConfig[Number(pins.feedMotor)]?.label
  const feedMotorColor = pins?.feedMotor && feedMotorConfig[Number(pins.feedMotor)]?.color

  // Size and aspect ratio
  const _aspectRatio = (size === EsfStationSizes.normal) ? 280 : 320
  const aspectRatio = 170 / _aspectRatio;

  let sizeValue: number;
  switch (size) {
  case EsfStationSizes.small:
      sizeValue = 280;
    break;
  case EsfStationSizes.normal:
    default:
      sizeValue = 600;
    break;
  }
  
  const width = sizeValue;
  const height = sizeValue * aspectRatio;

  // ViewBox dimensions
  const minY = size === EsfStationSizes.normal ? 18.7146 : 0
  const minX = 0;
  const maxY = 170.538
  const maxWidth = size === EsfStationSizes.normal ? 250 : 330;
  const maxHeight = maxY - minY;
  
  // Text font sizes
  const baseSvgWidth = width / maxWidth;
  const scaledPrimaryFontSize = 14 / baseSvgWidth;
  const scaledSecondaryFontSize = 12 / baseSvgWidth;
  const scaledTertiaryFontSize = 16 / baseSvgWidth;

  const animation = `
    @keyframes pulseOpacity {
      0% { opacity: 0.2; }
      25% { opacity: 1; }
      50% { opacity: 1; }
      75% { opacity: 1; }
      100% { opacity: 0.2; }
    }
  `

  return (<>
    <style>{animation}</style>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`${minX} ${minY} ${maxWidth} ${maxHeight}`} fill="none" style={{ overflow: "visible" }}>
      
      {/* Walls */}
      <path // Back wall
        d="M7.83816 154.59L45.653 139.641H178.785C181.546 139.641 183.785 137.403 183.785 134.641V64.2803C183.785 61.5188 181.546 59.2803 178.785 59.2803H45.653L4.10975 76.2448C2.22908 77.0127 1 78.8423 1 80.8737V149.94C1 153.469 4.55658 155.888 7.83816 154.59Z"
        fill={colors.greyLightSecondary}
        stroke={colors.greyTertiary}
        strokeWidth={ size === EsfStationSizes.normal ? 0.8 : 1.4}
      />
      <path // Front wall
        d="M31.6086 169.301L74.466 153.093H196.002C198.763 153.093 201.002 150.854 201.002 148.093V78.8481C201.002 76.0867 198.763 73.8481 196.002 73.8481H74.466L28.024 91.9501C26.1041 92.6984 24.8398 94.548 24.8398 96.6087V164.625C24.8398 168.122 28.3377 170.538 31.6086 169.301Z"
        fill={colors.graphBlueTen}
        stroke={colors.greyDarkSecondary}
        strokeWidth={ size === EsfStationSizes.normal ? 0.8 : 1.4}
      />
      <line // Front wall vertical line
        x1="75.668" y1="80.4722" x2="75.668" y2="146.697"
        stroke={colors.graphBlueEight}
      />
      {size === EsfStationSizes.normal ? (
        <path // Back wall vertical line
          d="M46.0058 64.678V82.8718"
          stroke={colors.greyLightPrimary}
        />) : (<></>)
      }
           
      {/* Feed container */}
      {size === EsfStationSizes.normal ? (<>
        <path // Upper feed container
          d="M57.3713 24.1716L52.547 25.4704C50.364 26.0581 48.8469 28.0377 48.8469 30.2985V44.761C48.8469 45.4784 49.0013 46.1874 49.2995 46.8398L53.1502 55.2632C53.9638 57.0429 55.7408 58.1844 57.6976 58.1844H76.622C79.3834 58.1844 81.622 55.9459 81.622 53.1844V28.9996C81.622 26.2382 79.3834 23.9996 76.622 23.9996H58.6711C58.2322 23.9996 57.7951 24.0574 57.3713 24.1716Z"
          fill="#4D6786"
          stroke="#3B4143"
          strokeWidth={0.8}
        />
        <path // Lower feed container
          d="M76.622 50.0788H62.2792C60.5074 50.0788 58.8679 51.0165 57.9696 52.5437L53.0614 60.8875C52.6094 61.6559 52.3711 62.5311 52.3711 63.4226V65.1717C52.3711 67.1393 53.525 68.9239 55.3193 69.7313L58.4409 71.136C59.086 71.4263 59.7853 71.5764 60.4927 71.5764H76.622C79.3834 71.5764 81.622 69.3379 81.622 66.5764V55.0788C81.622 52.3173 79.3834 50.0788 76.622 50.0788Z"
          fill="#4D6786"
          stroke="#3B4143"
          strokeWidth={0.8}
        />
        <path // Upper feed container vertical line
          d="M58.7147 27.1714V46.5546"
          stroke="#5B7691"
        />
        <path // Lower feed container vertical line
          d="M58.7147 56.4224L58.7147 68.4047"
          stroke="#5B7691"
        />
      </>) : (<>
        <path // Upper feed container
          d="M29.4974 1.17192L20.5712 3.57507C18.3882 4.16282 16.8711 6.14235 16.8711 8.40316V31.5424C16.8711 32.2598 17.0255 32.9688 17.3237 33.6212L23.6987 47.5662C24.5123 49.3458 26.2892 50.4873 28.246 50.4873H59.3185C62.08 50.4873 64.3185 48.2488 64.3185 45.4873V6C64.3185 3.23858 62.08 1 59.3185 1H30.7973C30.3583 1 29.9213 1.0578 29.4974 1.17192Z"
          fill={colors.graphBlueTen}
          stroke={colors.greyDarkSecondary}
          strokeWidth={1.4}
        />
        <path // Lower feed container
          d="M59.3456 38.7554H35.0635C33.2916 38.7554 31.6522 39.6931 30.7538 41.2202L22.6903 54.9279C22.2383 55.6963 22 56.5715 22 57.463V62.0517C22 64.0193 23.1539 65.8039 24.9482 66.6114L31.2251 69.4359C31.8702 69.7262 32.5695 69.8763 33.2769 69.8763H59.3456C62.107 69.8763 64.3456 67.6377 64.3456 64.8763V43.7554C64.3456 40.9939 62.107 38.7554 59.3456 38.7554Z"
          fill={colors.graphBlueTen}
          stroke={colors.greyDarkSecondary}
          strokeWidth={1.4}
        />
        <path // Upper feed container vertical line
          d="M31.1836 5.59131V33.6511"
          stroke={colors.graphBlueEight}
        />
        <path // Lower feed container vertical line
          d="M31.1836 47.9375L31.1836 65.2836"
          stroke={colors.graphBlueEight}
        />
      </>)}

      {/* Pins */}
      {size === EsfStationSizes.normal ? (<>
        {pins&&pins.components ? ( <>
          <path // Feed Motor Pin
            d={`M69.4663 29.4873L69.4663 18.7146`}
            stroke={colors.graphBlueSeven}
            strokeWidth="1"
          />
          <path // Feed Motor Pin
            d={`M0 19 H${maxWidth}`}
            stroke={colors.graphBlueSeven}
            strokeWidth="1"
          />
          <mask id="mask3_198_402" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="64" y="26" width="11" height="11">
            <path
              transform="translate(69.4384, 31.614) scale(1.2) translate(-69.4384, -31.614)"
              d="M64.6784 36.374L64.6784 26.854L67.8517 26.854L67.8517 28.758L71.0251 28.758L71.0251 26.854L74.1984 26.854L74.1984 36.374L67.8517 36.374L64.6784 36.374Z"
              fill={colors.graphBlueSeven}
            />
          </mask>
          <g mask="url(#mask3_198_402)">
            <path
              transform="translate(69.4381, 31.6143) scale(1) translate(-69.4381, -31.6143)"
              d="M65.5631 31.6143C65.5631 29.4741 67.2979 27.7385 69.4381 27.7383C71.5784 27.7383 73.314 29.474 73.314 31.6143C73.3139 33.7545 71.5782 35.4893 69.4381 35.4893C67.298 35.4891 65.5632 33.7543 65.5631 31.6143Z"
              stroke={colors.graphBlueSeven}
              strokeWidth="0.5"
              style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
            />
          </g>
          <ellipse cx="69.4385" cy="31.6121" rx="2.22133" ry="2.22134" transform="rotate(-90 69.4385 31.6121)" fill={colors.graphBlueSeven} />
        </>) : (<></>)}
      </>) : (<>
        <path // Feed Motor Pin
          d={`M44.7383 20.2209H58.4212L71.677 6.30225H189`}
          stroke="#728AA9"
          strokeWidth="2"
        />
        <text x={"75"} y={"27"} textAnchor="start" fontSize={scaledPrimaryFontSize} style={{ ...fonts.header }} fill={colors.greyDarkPrimary}>{t("esfWalkThroughPages.sections.feedMotor", {defaultValue: "feed motor"})}</text>
        { feedMotorText ? <circle cx={"79"} cy={"38"} r={3} fill={colors.greyDarkPrimary}/> : undefined}
        <text x={ feedMotorText ? "88" : "75"} y={"43"} textAnchor="start" style={{ ...(feedMotorText ? undefined : css.emptyPen), ...fonts.paragraph, fontSize: scaledSecondaryFontSize, opacity: feedMotorText ? "1" : "0.5" }} fill={pins?.feedMotor ? `${feedMotorColor}` : colors.greyDarkPrimary}>{feedMotorText ?? t("noData", { defaultValue: "no data" })}</text>
        <mask id="mask0_187_130" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="34" y="10" width="21" height="21">
          <path
            transform="translate(44.5068, 20.2207) scale(1.2) translate(-44.5068, -20.2207)"
            d="M34.5625 10.2793H54.4462V16.9072H50.4694V23.5351H54.4462V30.163H34.5625V16.9072V10.2793Z"
            fill="#728AA9"
          />
        </mask>
        <g mask="url(#mask0_187_130)">
          <path
            transform="translate(44.5068, 20.2207) scale(1.2) translate(-44.5068, -20.2207)"
            d="M44.5068 12.1045C48.9893 12.1045 52.623 15.7382 52.623 20.2207C52.623 24.7032 48.9893 28.3369 44.5068 28.3369C40.0244 28.3369 36.3906 24.7032 36.3906 20.2207C36.3907 15.7383 40.0244 12.1045 44.5068 12.1045Z"
            stroke={colors.graphBlueSeven}
            style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
          />
        </g>
        <ellipse cx="44.5067" cy="20.2211" rx="4.63952" ry="4.63953" fill="#728AA9" />
      </>)}
      
      {size === EsfStationSizes.normal ? (<>
        <path
          d={`M194.908 81.4355H250`}
          stroke={colors.graphBlueSeven}
          strokeWidth="1"
        />
        <text x={"205"} y={"89"} textAnchor="start" fontSize={scaledPrimaryFontSize} style={{ ...fonts.header }} fill={colors.greyDarkPrimary}>{t("esfWalkThroughPages.sections.gateMotor", {defaultValue: "gate motor"})}</text>
        { gateMotorText ? <circle cx={"206.5"} cy={"93.5"} r={"1.25"} fill={colors.greyDarkPrimary}/> : undefined }
        <text x={gateMotorText ? "210" : "205"} y={"95"} textAnchor="start" style={{ ...(gateMotorText ? undefined : css.emptyPen), ...fonts.paragraph, fontSize: scaledSecondaryFontSize, opacity: gateMotorText ? "1" : "0.5" }} fill={colors.greyDarkPrimary}>{gateMotorText ?? t("noData", { defaultValue: "no data" })}</text>
        
        <mask id="mask2_198_402" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="188" y="76" width="11" height="11">
          <path
            transform="translate(192.965, 81.4076) scale(1.2) translate(-192.965, -81.4076)"
            d="M188.205 76.6476H197.725V79.8209H195.821V82.9943H197.725V86.1676H188.205V79.8209V76.6476Z"
            fill={colors.graphBlueSeven}
          />
        </mask>
        <g mask="url(#mask2_198_402)">
          <path
            transform="translate(192.965, 81.4073) scale(1) translate(-192.965, -81.4073)"
            d="M192.965 77.5323C195.105 77.5323 196.84 79.2672 196.841 81.4073C196.841 83.5476 195.105 85.2833 192.965 85.2833C190.824 85.2831 189.09 83.5475 189.09 81.4073C189.09 79.2673 190.825 77.5325 192.965 77.5323Z"
            stroke={colors.graphBlueSeven}
            strokeWidth="0.5"
            style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
          />
        </g>
        <ellipse cx="192.967" cy="81.4077" rx="2.22133" ry="2.22134" fill={colors.graphBlueSeven} />
      </>) : ( <>
        <path 
          d={`M185.68 95.779H194.959L208.215 81.8604H330`}
          stroke={colors.graphBlueSeven}
          strokeWidth="2"
        />
        <text x={"210"} y={"103"} textAnchor="start" fontSize={scaledPrimaryFontSize} style={{ ...fonts.header }} fill={colors.greyDarkPrimary}>{t("esfWalkThroughPages.sections.gateMotor", {defaultValue: "gate motor"})}</text>
          {gateMotorText ? <circle cx={"214"} cy={"115"} r={"3"} fill={colors.greyDarkPrimary} /> : undefined}
        {/*  */}
        <text x={gateMotorText ? "223" : "210"} y={"119"} textAnchor="start" style={{ ...(gateMotorText ? undefined : css.emptyPen), ...fonts.paragraph, fontSize: scaledSecondaryFontSize, opacity: gateMotorText ? "1" : "0.5" }} fill={colors.greyDarkPrimary}>{gateMotorText ?? t("noData", { defaultValue: "no data" })}</text>
        {/*  */}
        <mask id="mask1_187_130" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="171" y="85" width="21" height="21">
          <path
            transform="translate(181.042, 95.7788) scale(1.2) translate(-181.042, -95.7788)"
            d="M171.098 85.8374H190.981V92.4653H187.005V99.0932H190.981V105.721H171.098V92.4653V85.8374Z"
            fill={colors.graphBlueSeven}
          />
        </mask>
        <g mask="url(#mask1_187_130)">
          <path
            transform="translate(181.042, 95.7788) scale(1.2) translate(-181.042, -95.7788)"
            d="M181.042 87.6626C185.524 87.6626 189.158 91.2963 189.158 95.7788C189.158 100.261 185.524 103.895 181.042 103.895C176.56 103.895 172.926 100.261 172.926 95.7788C172.926 91.2964 176.56 87.6626 181.042 87.6626Z"
            stroke={colors.graphBlueSeven}
            style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
          />
        </g>
        <ellipse cx="181.046" cy="95.7792" rx="4.63952" ry="4.63953" fill={colors.graphBlueSeven} />
      </>)} 
    </svg>
    </>);
}